<template>
  <div>
    <input ref="fileUploadRef" :disabled="disabled" :name="name" multiple :accept="accept" hidden type="file" @change="checkFile">
    <!-- 选择模式 -->
    <div class="">
      <div v-if="!disabled" class="flex-center pointer primary-icon" @click.capture="selectFile">
        <svg t="1628144846509" class="icon" viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg" p-id="1968" width="30" height="30">
          <path d="M1022.955204 556.24776c0 100.19191-81.516572 181.698249-181.718715 181.698249l-185.637977 0c-11.2973 0-20.466124-9.168824-20.466124-20.466124 0-11.307533 9.168824-20.466124 20.466124-20.466124l185.637977 0c77.628008 0 140.786467-63.148226 140.786467-140.766001 0-77.423347-62.841234-140.448776-140.203182-140.766001-0.419556 0.030699-0.828878 0.051165-1.248434 0.061398-5.935176 0.153496-11.665691-2.302439-15.666818-6.702656-4.001127-4.41045-5.884011-10.345626-5.157463-16.250102 1.330298-10.806113 1.944282-19.760043 1.944282-28.192086 0-60.763922-23.658839-117.874641-66.617234-160.833035-42.968627-42.958394-100.089579-66.617234-160.843268-66.617234-47.368844 0-92.742241 14.449084-131.208321 41.781592-37.616736 26.738991-65.952084 63.700811-81.925894 106.884332-2.425236 6.54916-8.012488 11.399631-14.827707 12.893658-6.815219 1.483794-13.927197-0.603751-18.859533-5.536087-19.289322-19.340487-44.943608-29.982872-72.245418-29.982872-56.322773 0-102.146425 45.813419-102.146425 102.125959 0 0.317225 0.040932 0.982374 0.092098 1.627057 0.061398 0.920976 0.122797 1.831718 0.153496 2.762927 0.337691 9.465582-5.863545 17.928325-15.001669 20.455891-32.356942 8.943696-61.541635 28.550243-82.181721 55.217602-21.305235 27.516704-32.571836 60.508096-32.571836 95.41307 0 86.244246 70.188572 156.422585 156.443052 156.422585l169.981393 0c11.2973 0 20.466124 9.15859 20.466124 20.466124 0 11.2973-9.168824 20.466124-20.466124 20.466124l-169.981393 0c-108.828614 0-197.3753-88.536452-197.3753-197.354833 0-44.053332 14.223956-85.712127 41.126676-120.473839 22.809495-29.450752 53.897537-52.086285 88.710414-64.816215 5.065366-74.322729 67.149353-133.2447 142.751215-133.2447 28.386514 0 55.504128 8.217149 78.651314 23.52581 19.657712-39.868009 48.842405-74.169233 85.497233-100.212376 45.434795-32.295544 99.004875-49.354058 154.918325-49.354058 71.692832 0 139.087778 27.915793 189.782368 78.600149 50.694589 50.694589 78.610382 118.089535 78.610382 189.782368 0 3.704368-0.102331 7.470135-0.296759 11.368932C952.633602 386.245901 1022.955204 463.188294 1022.955204 556.24776zM629.258611 589.106122c-3.990894 3.990894-9.230222 5.996574-14.46955 5.996574s-10.478655-2.00568-14.46955-5.996574l-67.087954-67.077721 0 358.689289c0 11.307533-9.15859 20.466124-20.466124 20.466124-11.307533 0-20.466124-9.15859-20.466124-20.466124l0-358.689289-67.087954 67.077721c-7.992021 7.992021-20.947078 7.992021-28.939099 0s-7.992021-20.957311 0-28.949332l102.023628-102.013395c7.992021-7.992021 20.947078-7.992021 28.939099 0l102.023628 102.013395C637.250632 568.148811 637.250632 581.114101 629.258611 589.106122z"
                p-id="1969" fill="#bfbfbf" />
        </svg>
        <span class="mg-l-10 opacity-30">{{ $L('UPLOAD') }}</span>
      </div>
      <SpScroll>
        <div v-for="(file,index) in fileList" class="mg-l-20 opacity-50">
          <span class="pointer" style="overflow: hidden" @click.capture="showFullView(file)">{{ file.name }}</span>
          <svg v-if="!disabled" class="mg-l-20 pointer" t="1627975144040" viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg" p-id="8416" width="20" height="20" @click.capture="deleteFile(index)">
            <path d="M731.3 296.1c-120.7-120.7-316.4-120.7-437 0s-120.7 316.4 0 437c120.7 120.7 316.4 120.7 437 0 120.6-120.7 120.6-316.4 0-437z m-93.4 395.1L512.6 566 387.9 690.7c-14.1 14.1-36.9 14.1-50.9 0-14.1-14.1-14.1-36.9 0-50.9l124.7-124.7-124.3-124.4c-14.1-14.1-14.1-36.9 0-50.9 14.1-14.1 36.9-14.1 50.9 0l124.4 124.4L639 337.9c14.1-14.1 36.9-14.1 50.9 0 14.1 14.1 14.1 36.9 0 50.9L563.5 515.1l125.3 125.3c14.1 14.1 14.1 36.9 0 50.9s-36.9 14-50.9-0.1z"
                  p-id="8417" fill="#bfbfbf" />
          </svg>
        </div>
      </SpScroll>
    </div>
    <!-- 预览弹窗 -->
    <sp-drawer v-if="file.url" v-model="fullView">
      <img v-if="imglist.includes(file.type)&&file.url" class="img" :src="file.url">
      <iframe v-else-if="file.type=='pdf'&&file.url" scrolling="no" width="100%" height="700px" frameborder="0"
              :src="file.url" />
      <div v-else="file.type=='other'&&file.url" class="text-center">
        <p class="fw-bold mg-b-20">
          This file does not support preview yet
        </p>
        <br>
        <br>

        <a class="mg-t-30" style="color:#3A909D;margin-top: 30px" :href="file.url" download="file.name"> {{ file.name }}</a>
        <svg v-if="file.type=='other'&&file.url" t="1628148530356" class="icon" viewBox="0 0 1024 1024"
             version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2858" width="200" height="200">
          <path d="M858.251002 65.538669 709.22692 65.538669l-0.204661 0.184195c-0.112564 0-0.204661-0.038886-0.312108-0.038886-13.967106 0-25.461905 10.3006-27.538193 23.667026l-0.248663 0.225127c-7.556093 33.045627-18.427698 76.41232-53.822836 76.41232l-246.183935-1.517563c-34.927487 0-45.37442-42.771129-53.413514-75.16491-1.36509-13.386892-12.069897-23.892153-25.568329-24.910343l-0.370437-0.375553L165.181063 64.020082c-20.552082 0-37.239136 16.666588-37.239136 37.239136l0 819.454394c0 20.571525 16.686031 37.238113 37.239136 37.238113l693.049472 1.517563c20.557198 0 37.239136-16.666588 37.239136-37.238113L895.469672 102.777805C895.490138 82.205257 878.788757 65.538669 858.251002 65.538669L858.251002 65.538669 858.251002 65.538669zM858.251002 922.232199l-693.069939-1.517563L165.181063 101.260242l126.998439 0c9.087982 36.459377 26.38288 100.44569 88.810698 100.44569l246.183935 1.517563c62.952774 0 80.69281-64.810075 88.940658-100.44569L858.230536 102.777805l0 819.454394L858.251002 922.232199 858.251002 922.232199 858.251002 922.232199zM407.172513 101.372805l209.110575 1.517563c10.295484 0 18.61701-8.346085 18.61701-18.622126 0-10.277064-8.321526-18.61701-18.61701-18.61701L407.172513 64.133669c-10.281157 0-18.622126 8.339946-18.622126 18.61701C388.550387 93.025697 396.891356 101.372805 407.172513 101.372805L407.172513 101.372805 407.172513 101.372805zM246.674099 381.845685c0 10.276041 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.340969 18.622126-18.61701 0-10.277064-8.326643-18.622126-18.622126-18.622126l-497.744321-1.517563C255.014044 363.223558 246.674099 371.56862 246.674099 381.845685L246.674099 381.845685 246.674099 381.845685zM763.03543 542.794353l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.61701 0 10.3006 8.339946 18.622126 18.61701 18.622126l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.622126C781.657556 551.115879 773.330914 542.794353 763.03543 542.794353L763.03543 542.794353 763.03543 542.794353zM763.03543 719.526497l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.622126 0 10.295484 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.61701C781.657556 727.848023 773.330914 719.526497 763.03543 719.526497L763.03543 719.526497 763.03543 719.526497zM763.03543 719.526497"
                p-id="2859" fill="#bfbfbf" />
        </svg>
      </div>
    </sp-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import { include } from '@/utils/check'
import spDrawer from '@/components/common/SpDrawer'
import { ref, toRef } from '@vue/reactivity'
import { checkFileUpdated, uploadFile, removeFile } from '@/request/APIs/file'
import CryptoJS from 'crypto-js'
import { computed, watch } from 'vue'
import SpScroll from '@/components/common/SpScroll'
import useForm from '@/hooks/useForm'
import _includes from 'lodash/includes'

export default {
  name: 'SpUpload',

  nameSpace: 'SpUpload',

  components: {
    SpScroll,
    spDrawer
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    maxCount: {
      type: Number,
      default: 5
    },

    accept: {
      type: String,
      default: 'MIME_type'// 可选 audio/* video/* image/* MIME_type
    },

    uploadAfterSelect: { // 选择后自动上传
      type: Boolean,
      default: true
    },

    defaultFiles: {
      type: Array,
      default: () => []
    },

    fileType: { // 文件类型，后端需要
      type: String,
      default: ''
    },

    name: { // html-name
      type: String,
      default: ''
    },

    businessId: { // 主数据id，后端需要
      type: String,
      default: ''
    },

    splitter1: {
      type: Number,
      default: () => null
    },

    splitter2: {
      type: Number,
      default: () => null
    },

    splitter3: {
      type: Number,
      default: () => null
    }
  },

  emits: ['update:modelValue'],
  setup (props, ctx) {
    const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
    const doc = ['docx', 'doc']
    const docRef = ref(null)

    const fileUploadRef = ref(null)
    const fileList = ref([...(props.defaultFiles || [])])
    const file = ref({})
    const fullView = ref(false)
    watch(() => props.defaultFiles, (nv) => {
      fileList.value = []
      fileList.value.push(...nv)
    })

    const model = computed(() => {
      return {
        fileList,
        upload,
        uploadAll
      }
    })

    useForm(props.name ? toRef(props, 'name') : toRef(props, 'fileType'), 'file', model)

    // 选择文件
    const selectFile = () => {
      fileUploadRef.value.click()
    }

    // 显示预览
    const showFullView = (files) => {
      // 后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      try {
        const flieArr = files.url.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // console.log(suffix)
      // if (_includes(imglist, suffix)) {
      //   file.value = files
      //   file.value.type = suffix
      //   fullView.value = true
      // } else if (_includes(doc, suffix)) {
      //   // axios.post(files.url, {}, { responseType: 'blob' }).then(res => {
      //   //   const blob = new Blob([res.data])// 处理文档流
      //   //   const fileName = '资产列表.xlsx'
      //   //   renderAsync(res.data, docRef.value)
      //   // })
      //
      const config = {
        responseType: 'blob'
      }
      // axios.request({
      //   url: files.url,
      //   method: 'post',
      //   responseType: 'blob',
      //   headers: {
      //     'Access-Control-Allow-Origin': '*',
      //     'Content-type': 'application/x-www-form-urlencoded'
      //   }
      // }).then(res => {
      //
      // })

      file.value = files
      file.value.type = suffix
      fullView.value = true
    }

    // 检查文件
    const checkFile = async () => {
      const files = fileUploadRef.value.files

      if (files.length > 0) {
        const restCount = props.maxCount - fileList.value.length
        for (let i = 0; i < restCount && i < files.length; i++) {
          const file = files[i]
          // console.log(file)
          const url = window.URL.createObjectURL(file)
          const fileLocal = { name: file.name, url: url, file: file }
          if (file.type.includes('image')) {
            fileLocal.type = 'img'
          } else if (include(file.type, 'pdf', 'text')) {
            fileLocal.type = 'pdf'
          } else {
            fileLocal.type = 'other'
          }
          const reader = new FileReader()
          reader.readAsArrayBuffer(file)
          await new Promise((resolve, reject) => {
            reader.onload = function () {
              const wordArray = CryptoJS.lib.WordArray.create(reader.result)
              const hash = CryptoJS.SHA256(wordArray).toString()
              fileLocal.hash = hash
              resolve()
            }
          })
          fileList.value.push(fileLocal)
          if (props.uploadAfterSelect) {
            uploadAll()
          }
        }
      }
    }
    // 删除文件
    const deleteFile = (index) => {
      if (!fileList.value[index]?.id) {
        fileList.value.splice(index, 1)
      } else {
        removeFile({ type: props.fileType, id: props.businessId, fid: fileList.value[index].id }).then(res => {
          fileList.value.splice(index, 1)
        })
      }
    }

    const upload = (file) => {
      if (file.file) {
        checkFileUpdated({
          type: props.fileType,
          id: props.businessId,
          hash: file.hash,
          splitter1: props.splitter1,
          splitter2: props.splitter2,
          splitter3: props.splitter3
        }).then(res => {
          if (!res.updated) {
            uploadFile({
              type: props.fileType,
              id: props.businessId,
              upload: file.file,
              splitter1: props.splitter1,
              splitter2: props.splitter2,
              splitter3: props.splitter3
            }).then((res) => {
              console.log(res)
            }).catch(err => {
              console.log(err)
            })
          }
        })
      }
    }

    const uploadAll = () => {
      fileList.value.forEach(file => {
        upload(file)
      })
    }
    return {
      fileUploadRef,
      fileList,
      file,
      uploadAll,
      deleteFile,
      checkFile,
      fullView,
      selectFile,
      showFullView,
      imglist
    }
  }

}
</script>

<style scoped lang="less">
    .SpUpload {
        border: 1px solid #c0ccda;
        border-radius: 5px;
        position: relative;

        .main {
          text-align: center;
            overflow: hidden;

            .preview-iframe {
                overflow: hidden;
                pointer-events: none;
            }
        }

        .close-icon {
            background-color: white;
            border-radius: 80px;
            position: absolute;
            top: @gap/1.1*-1;
            right: @gap/1.1*-1;
            z-index: 10;
        }

        .mask {
            position: absolute;
            cursor: pointer;
            background-color: white;
            opacity: 0.01;
            z-index: 100;
            top: @gap;
        }
    }

    .img {
        object-fit: contain;
        width: 100%;
        height: 280px
    }

    .primary-icon {
        width: 155px;
        height: 53px;
        background: #F6F6F6;
        border: 1px solid #CDCDCD;
        border-radius: 5px;
    }
</style>
